import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { AuthProvider, RequireAdmin, RequireAuth } from '@/lib/auth';
import { DashboardPage } from '@/routes/DashboardPage';
import { LeadsPage } from '@/routes/LeadsPage';
import { LeadDetailPage } from '@/routes/LeadDetailPage';
import { AssignmentsPage } from '@/routes/AssignmentsPage';
import { CallQueuePage } from '@/routes/CallQueuePage';
import { CallingWorkspacePage } from '@/routes/CallingWorkspacePage';
import { FollowUpsPage } from '@/routes/FollowUpsPage';
import { ImportsPage } from '@/routes/ImportsPage';
import { ImportDetailPage } from '@/routes/ImportDetailPage';
import { DuplicatesPage } from '@/routes/DuplicatesPage';
import { CustomersPage } from '@/routes/CustomersPage';
import { ReportsPage } from '@/routes/ReportsPage';
import { ResearchAgentPage } from '@/routes/ResearchAgentPage';
import { SettingsPage } from '@/routes/SettingsPage';
import { PhoneLinesPage } from '@/routes/PhoneLinesPage';
import { EmailListPage } from '@/routes/EmailListPage';
import { OperationsPage } from '@/routes/OperationsPage';
import { LoginPage } from '@/routes/LoginPage';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Outside the shell and outside RequireAuth, so it is always reachable. */}
          <Route path="/login" element={<LoginPage />} />

          {/*
            RequireAuth is a no-op while the server reports auth.enabled = false,
            which is the whole of Phase 1. Anonymous users reach every screen
            exactly as they do today.
          */}
          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/leads/:id" element={<LeadDetailPage />} />
            <Route path="/queue" element={<CallQueuePage />} />
            <Route path="/queue/:sessionId" element={<CallingWorkspacePage />} />
            <Route path="/follow-ups" element={<FollowUpsPage />} />

            {/*
              The server remains the authority for these pages. This client gate
              prevents a VA from manually typing an admin URL and seeing a
              half-rendered page before those API calls are rejected.
            */}
            <Route element={<RequireAdmin />}>
              <Route path="/assignments" element={<AssignmentsPage />} />
              <Route path="/imports" element={<ImportsPage />} />
              <Route path="/imports/:id" element={<ImportDetailPage />} />
              <Route path="/duplicates" element={<DuplicatesPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/operations" element={<OperationsPage />} />
              <Route path="/email-list" element={<EmailListPage />} />
              <Route path="/research-agent" element={<ResearchAgentPage />} />
              <Route path="/phone-lines" element={<PhoneLinesPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
